import IconModel from './IconModel'

export default class QuestionModel {
    store; //AppStore
    id; // uuid
    icons = []; // array
    text; // string
    type; // icon, polyline, polygon

    constructor(store, id, type, text) {
        this.store = store;
        this.id = id;
        this.type = type;
        this.text = text;
    }

    static fromJS(store, object, type, icons) {
        let questions = new QuestionModel(store, object.id, type, object.text);
        questions.icons = icons.map(icon => IconModel.fromJS(store, icon, type));
        return questions;
    }
}


// WEBPACK FOOTER //
// ./src/models/QuestionModel.js